import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getMobileSdkIssue } from 'src/apps/mobile-sdk/services/MobileSdkSingleTestService';
import { IMobileSdkIssueData } from 'src/apps/mobile-sdk/services/queries/issue/helpers/transformResults';
import { MOBILE_SDK_ISSUE } from 'src/common/providers/reactQueryProvider/QueryKeys';

export const useMobileSdkIssueQuery = (
	issueId: string,
	testId: string
): UseQueryResult<IMobileSdkIssueData | null> => {
	const issueQuery = useQuery([MOBILE_SDK_ISSUE, issueId, testId], () =>
		getMobileSdkIssue(issueId, testId)
	);

	return issueQuery;
};
